import React from 'react';
import { getFlattenedChildren } from '@tanium/coreui-utils';
import { Box } from '@tanium/react-box';
import { BreadcrumbCaret } from '@tanium/react-graphics';
import { ThemeColors } from '@tanium/theme-data';

interface Props {
  /**
   * The breadcrumbs to display.
   */
  children: React.ReactNode;
}

/**
 * Component for displaying a series of navigational breadcrumbs. Each child should be a Breadcrumb
 * component.
 */
export const BreadcrumbSet = ({ children: childrenProp }: Props) => {
  const flattenedChildren = React.Children.toArray(getFlattenedChildren(childrenProp));

  const children = Array.isArray(flattenedChildren)
    ? flattenedChildren.map((child, i) => [
        child,
        // eslint-disable-next-line react/no-array-index-key -- index is best key available
        <Box key={`separator-${i}`} as="span" color={ThemeColors.Subtle}>
          {' '}
          <BreadcrumbCaret />{' '}
        </Box>,
      ])
    : flattenedChildren;

  return <>{children}</>;
};
